import React, { Component } from 'react';
import { View, Animated, TouchableOpacity } from 'react-native';

import PropTypes from 'prop-types';

import styles from './CollapsibleCard.Styles';

class CollapsibleCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      animation: new Animated.Value(this.props.cardHeight),
    };
  }

  componentDidUpdate() {
    if (this.state.collapse && this.props.openId !== this.props.id) {
      this.collapse('clear');
    }
  }

  startpoint = layout => {
    this.setState({
      startpoint: layout.nativeEvent.layout.height,
    });
  };

  endpoint = layout => {
    this.setState({
      endpoint: layout.nativeEvent.layout.height,
    });
  };

  _handlePressCard = () => {
    this.props.handlePress();
    this.collapse();
  };

  collapse = action => {
    const { startpoint, endpoint, collapse } = this.state;
    let startAnim = 0;
    let endAnim = 0;
    if (action === 'clear') {
      startAnim = endpoint + startpoint;
      endAnim = startpoint;
      this.animateHeight(startAnim, endAnim);
    } else {
      startAnim = collapse ? endpoint + startpoint : startpoint;
      endAnim = collapse ? startpoint : startpoint + endpoint;
      this.animateHeight(startAnim, endAnim);
    }

    this.setState({ collapse: !this.state.collapse });
  };

  animateHeight(startAnim = 0, endAnim = 0) {
    this.state.animation.setValue(startAnim);
    Animated.spring(this.state.animation, {
      toValue: endAnim,
      useNativeDriver: false,
    }).start();
  }

  render() {
    return (
      <Animated.View
        style={[styles.containerAnimated, this.props.cardStyle, { height: this.state.animation }]}
      >
        <TouchableOpacity
          activeOpacity={1}
          onLayout={this.startpoint}
          onPress={this._handlePressCard}
        >
          {this.props.renderCard()}
        </TouchableOpacity>
        <View onLayout={this.endpoint}>{this.props.renderCollapseCard()}</View>
      </Animated.View>
    );
  }
}

CollapsibleCard.propTypes = {
  renderCard: PropTypes.func,
  renderCollapseCard: PropTypes.func,
  cardHeight: PropTypes.number,
  cardStyle: PropTypes.object,
  id: PropTypes.number,
  openId: PropTypes.number,
  handlePress: PropTypes.func,
};
CollapsibleCard.defaultProps = {
  renderCard: () => { },
  renderCollapseCard: () => { },
  cardHeight: 0,
  cardStyle: {},
  id: null,
  openId: null,
  handlePress: () => { },
};
export default CollapsibleCard;
